<script lang="ts">
    import {catalog, selectedId} from '../stores';
    import {getCatalog} from "../repo";
    import Nav from "./Nav.svelte";
    import ModelTypePicker from "./ItemTypePicker.svelte";
    import ModelDetails from "./ItemDetails.svelte";
    import {Model} from "../entities/Model";
    import SectionArrow from "./SectionArrow.svelte";
    import ItemSummary from "./ItemSummary.svelte";
    import {OfferRequest} from "../entities/OfferRequest";
    import {OfferItem} from "../entities/OfferItem";
    import {LedExtras} from "../entities/LedExtras";
	import SubmitInput from "./SubmitInput.svelte";
	import OfferFinished from "./OfferFinished.svelte";
    import {onMount} from "svelte";
    import ModalComponent from "./extras/ModalComponent.svelte";
    import GdprBanner from '@beyonk/gdpr-cookie-consent-banner'
    import '@beyonk/gdpr-cookie-consent-banner/dist/style.css'

    onMount(async () => {
        getCatalog().then(data => catalog.set(data))
    });

    let models: Model[];
    let selectedModel = Model;
    let offerFinished: Boolean = false
    let offerData = new OfferRequest("", "", "", "", "", [])
    let offerItems: OfferItem[] = []
    let currentItemIndex: number = 0
    let modalId = 0

    let currentItem: OfferItem = new OfferItem(
        true, null, 1500, 500, new LedExtras()
    )

    selectedId.subscribe(val => {
        selectedModel = models ? models.filter(x => x.id === val)[0] : null
        if (selectedModel) {
            currentItem = currentItem.copy({
                model: selectedModel,
                insulatedPanel: false,
                extras: new LedExtras(),
                widthValue: 350,
                projectionValue: 500
            })
            offerItems[currentItemIndex] = currentItem
        }
    })

    catalog.subscribe(val => {
        models = val.models;
    });

</script>

<svelte:head>
    <link rel="stylesheet" href="/global.css">
</svelte:head>

<style global>
	@tailwind base;
	@tailwind components;
	@tailwind utilities;
</style>
<!--<Route path="preview">
</Route>-->
<main class="3xl:container m-auto pb-16">
    <ModalComponent bind:id={modalId}/>
    <Nav/>
    <div class="flex justify-center">
        <img src="icons/logo.png" class="h-16" alt="palmiye logo">
    </div>
    {#if offerFinished === false}
        <div class="flex flex-col text-white">
            <div class="flex items-center justify-center py-3 mt-3">
                <h1 class="text-white text-5xl font-bold">Kérj ajánlatot 3 egyszerű lépésben!</h1>
            </div>
            <SectionArrow/>
            <ModelTypePicker models="{models}"/>
            <ModelDetails bind:modalId={modalId} bind:offerItems={offerItems} bind:currentItem="{currentItem}"
                          bind:currentItemIndex="{currentItemIndex}"/>
            {#if offerItems.length > 0}
                <ItemSummary bind:offerItems={offerItems} bind:currentItem="{currentItem}"
                             bind:currentItemIndex="{currentItemIndex}"/>
                <SubmitInput offerData={offerData} offerItems={offerItems} bind:offerSent="{offerFinished}"/>
            {/if}
        </div>
    {:else }
       <OfferFinished/>
    {/if}
    <GdprBanner cookieName="cookie_cons" description="Hozzájárulok ahhoz, hogy a weboldalon viselkedésalapú/remarketing sütik fussanak. <a target='_blank' href='https://teraszarnyekolok.hu/adatvedelem/'>További információk</a>" showEditIcon={false} acceptLabel="Elfogadom" settingsLabel={null}/>
</main>
